module.exports = __webpack_public_path__ + "img/atalanta.f81fa65e.png";